import React from 'react';
import { Box, Divider, Menu, MenuItem, Typography } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';

export interface UserAccountPopupMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
}

/** Popover only: user details + logout; anchor is the sidebar user button in `Menu.tsx`. */
const UserAccountPopupMenu: React.FC<UserAccountPopupMenuProps> = ({
  anchorEl,
  open,
  onClose,
}) => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    onClose();
    await logout();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      slotProps={{
        paper: {
          sx: { minWidth: 260 },
        },
      }}
      
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="body1" fontWeight={600}>
          {user?.name || 'Unnamed user'}
        </Typography>
        {user?.email ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, wordBreak: 'break-word' }}>
            {user.email}
          </Typography>
        ) : null}
        {user?.phone ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {user.phone}
          </Typography>
        ) : null}
      </Box>
      <Divider />
      <MenuItem
        onClick={() => void handleLogout()}
        sx={{ gap: 1, p: 2, color: 'error.main', justifyContent: 'space-between' }}
      > 
        Logout
        <Logout fontSize="small" />
      </MenuItem>
    </Menu>
  );
};

export default UserAccountPopupMenu;
